export default __webpack_public_path__ + "static/media/create_ac_checkmark.44391f16.svg";